<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 content-class="round-2xl")
  v-card
    v-card-title.pa-0
    .px-6.pt-2
      .text-lg.font-medium.mt-6 {{ $t('delete_confirmation', { text: $t('tax').toLowerCase() }) }}
      .text-md.mt-4 {{ $t('delete_confirmation_desc', { text: $t('tax').toLowerCase() }) }}
      .text-md.mt-2 {{ $t('click_confirm_to_proceed') }}
    v-divider.mt-6
    v-card-actions.px-6.py-3
      v-btn.button-md.neutral700--text.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="deleteItem" :loading="isLoading" color="danger500" depressed dark) {{ $t('confirm') }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DeleteTaxDialog',
  props: ['open', 'tax'],
  data: () => ({
    isLoading: false
  }),
  computed: {
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    deleteItem () {
      this.isLoading = true
      this.$axios.delete(`/tax_rates/${this.tax.id}`)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.field_deleted_successfully')])
          this.$emit('onDeleted')
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>